export const LESSONS =
[
    {
      lesson: 1,
      content: 
<>
<h2>Lesson One</h2>
<h4>So good that…</h4>
                            
<p>In English, we often say that something was so something, that it causes something to happen. It was so cold that I stayed in, it was so tasty I couldn&rsquo;t stop eating, it is so heavy he can&rsquo;t lift it, Gaelic&rsquo;s so easy that everyone should learn it.</p>

<p>In Gaelic this is easy - we just use the word cho and the word agus (in this structure, very often shortened to is or just &lsquo;s), followed by the &ldquo;gu&rdquo; or &ldquo;nach&rdquo; form of the verb. You will sometimes see this &lsquo;s written as agus. It&rsquo;s easiest explained with examples:</p>

<p>Bha e <strong>cho fuar</strong> <u>&lsquo;s nach robh</u> mi ag iarraidh dol a-mach</p>
<p>Tha am biadh seo <strong>cho blasta</strong> <u>&lsquo;s nach urrainn</u> dhomh stad bho bhith ga ithe!</p>
<p>Tha a&rsquo; Gh&agrave;idhlig <strong>cho furasta</strong> <u>agus gum bu ch&ograve;ir</u> dhan a h-uile duine a h-ionnsachadh</p>
<p>Easy!</p>                     
</>
    },


    {
        lesson: 2,
        content: 
  <>
  <h2>Lesson Two</h2>
  <h4>Lesson 2</h4>
                              
  <p>blah blah blah</p>                     
  </>
      },



      {
          lesson: 3,
          content: 
    <>
    <h2>Lesson Three</h2>
    <h4>Lesson 3</h4>
                                
    <p>blah blah blah</p>                     
    </>
        },
]
